import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=5aad30f8&scoped=true"
import script from "./ContentTitle.vue?vue&type=script&lang=js"
export * from "./ContentTitle.vue?vue&type=script&lang=js"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=5aad30f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad30f8",
  null
  
)

export default component.exports